import { useEffect, useMemo } from "react";
import "./DashBoard.css";
import TopBar from "../topbar/TopBar";
import { useState } from "react";
import { useRef } from "react";
import locationRed from "../../assets/svg/locationRed.svg";
import historyClock from "../../assets/svg/historyClock.svg";
import blueGate from "../../assets/svg/blueGate.svg";
import greenDepartment from "../../assets/svg/greenDepartment.svg";
import blueOrg from "../../assets/svg/blueOrg.svg";
import greyPurpose from "../../assets/svg/greyPurpose.svg";
import meetingPerson from "../../assets/svg/yellowPerson.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "react-circular-progressbar/dist/styles.css";
import {
  getLiveCountApi,
  getHistoryCountApi,
  getEntryCountApi,
  getRegistrationCountApi,
  getLocationCountApi,
  getGateCountApi,
  getDepartmentCountApi,
  getOrganizationCountApi,
  getPurposeCountApi,
  getMeetingPersonCountApi,
} from "./dashboard-api";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const VisitorDashboard = ({ data = [] }) => {
  const navigate = useNavigate();
  const currentMonth = new Date().toLocaleString("default", { month: "short" });
  const currentMonthData = data.find((item) => item.label === currentMonth);

  const [orgCreateDate, setOrgCreateDate] = useState("");

  const [activeDashboard, setActiveDashboard] = useState("Visitor Dashboard");

  const [liveCount, setLiveCount] = useState({});
  const [historyCount, setHistoryCount] = useState({});
  const [entryCount, setEntryCount] = useState({});
  const [registerCount, setRegisterCount] = useState({});
  const [locationBased, setLocationBased] = useState([]);
  const [gateBased, setGateBased] = useState([]);
  const [departmentBased, setDepartmentBased] = useState([]);
  const [orgBased, setOrgBased] = useState([]);
  const [purposeBased, setPurposeBased] = useState([]);
  const [meetingPersonBased, setMeetingPersonBased] = useState([]);

  useEffect(() => {
    getLiveCount();
    getHistoryCount();
    getEntryCount();
    getRegistrationCount();
    getLocationCount();
    getGateCount();
    getDepartmentCount();
    getOrganizationCount();
    getPurposeCount();
    getMeetingCount();
  }, []);

  const getLiveCount = async () => {
    try {
      const response = await getLiveCountApi();
      if (response.success === true) {
        setLiveCount(response.data ?? {});
        setOrgCreateDate(response.data?.from_date || "");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getHistoryCount = async () => {
    try {
      const response = await getHistoryCountApi();
      if (response.success === true) {
        setHistoryCount(response.data ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getEntryCount = async () => {
    try {
      const response = await getEntryCountApi();
      if (response.success === true) {
        setEntryCount(response.data ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getRegistrationCount = async () => {
    try {
      const response = await getRegistrationCountApi();
      if (response.success === true) {
        setRegisterCount(response.data ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getLocationCount = async () => {
    try {
      const response = await getLocationCountApi();
      if (response.success === true) {
        const data = response.data || [];
        setLocationBased(calculatePercentage(data));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getGateCount = async () => {
    try {
      const response = await getGateCountApi();
      if (response.success === true) {
        const data = response.data || [];
        setGateBased(calculatePercentage(data));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getDepartmentCount = async () => {
    try {
      const response = await getDepartmentCountApi();
      if (response.success === true) {
        const data = response.data || [];
        setDepartmentBased(calculatePercentage(data));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getOrganizationCount = async () => {
    try {
      const response = await getOrganizationCountApi();
      if (response.success === true) {
        const data = response.data || [];
        setOrgBased(calculatePercentage(data));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getPurposeCount = async () => {
    try {
      const response = await getPurposeCountApi();
      if (response.success === true) {
        const data = response.data || [];
        setPurposeBased(calculatePercentage(data));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getMeetingCount = async () => {
    try {
      const response = await getMeetingPersonCountApi();
      if (response.success === true) {
        const data = response.data || [];
        setMeetingPersonBased(calculatePercentage(data));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const calculatePercentage = (array) => {
    const total = array.reduce((s, it) => s + (Number(it.count) || 0), 0);
    return array.map((item) => ({
      ...item,
      percent: total === 0 ? 0.0 : ((Number(item.count) || 0) / total) * 100.0,
    }));
  };

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  // autoplay swipers
  // location
  const [activeLocation, setActiveLocation] = useState(0);
  const paginationCountLocation = chunkArray(locationBased, 5).length;
  const autoplayDelay = 10000;
  const swiperRefLocation = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveLocation((prev) => {
        const next = (prev + 1) % paginationCountLocation;
        // Move swiper slide
        if (swiperRefLocation.current) {
          swiperRefLocation.current.slideToLoop(next);
        }
        return next;
      });
    }, autoplayDelay);
    return () => clearInterval(interval);
  }, [paginationCountLocation]);

  // gate
  const [activeGate, setActiveGate] = useState(0);
  const paginationCountGate = chunkArray(gateBased, 5).length;
  const swiperRefGate = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveGate((prev) => {
        const next = (prev + 1) % paginationCountGate;

        // Move swiper slide
        if (swiperRefGate.current) {
          swiperRefGate.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountGate]);

  // department
  const [activeDepartment, setActiveDepartment] = useState(0);
  const paginationCountDepartment = chunkArray(departmentBased, 5).length;
  const swiperRefDepartment = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDepartment((prev) => {
        const next = (prev + 1) % paginationCountDepartment;

        // Move swiper slide
        if (swiperRefDepartment.current) {
          swiperRefDepartment.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountDepartment]);

  // organization
  const [activeOrganization, setActiveOrganization] = useState(0);
  const paginationCountOrganization = chunkArray(orgBased, 5).length;
  const swiperRefOrganization = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveOrganization((prev) => {
        const next = (prev + 1) % paginationCountOrganization;

        // Move swiper slide
        if (swiperRefOrganization.current) {
          swiperRefOrganization.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountOrganization]);

  // purpose
  const [activePurpose, setActivePurpose] = useState(0);
  const paginationCountPurpose = chunkArray(purposeBased, 5).length;
  const swiperRefPurpose = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActivePurpose((prev) => {
        const next = (prev + 1) % paginationCountPurpose;

        // Move swiper slide
        if (swiperRefPurpose.current) {
          swiperRefPurpose.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountPurpose]);

  // meeting person
  const [activeMeetingPerson, setActiveMeetingPerson] = useState(0);
  const paginationCountMeetingPerson = chunkArray(meetingPersonBased, 5).length;
  const swiperRefMeetingPerson = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveMeetingPerson((prev) => {
        const next = (prev + 1) % paginationCountMeetingPerson;

        // Move swiper slide
        if (swiperRefMeetingPerson.current) {
          swiperRefMeetingPerson.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [paginationCountMeetingPerson]);

  const MAX_DOTS = 5;

  const getVisibleDots = (total, active) => {
    if (total <= MAX_DOTS) {
      return { start: 0, end: total };
    }
    let start = active - Math.floor(MAX_DOTS / 2);
    let end = start + MAX_DOTS;

    if (start < 0) {
      start = 0;
      end = MAX_DOTS;
    }

    if (end > total) {
      end = total;
      start = total - MAX_DOTS;
    }

    return { start, end };
  };

  const { start: startLocation, end: endLocation } = useMemo(
    () => getVisibleDots(paginationCountLocation, activeLocation),
    [paginationCountLocation, activeLocation]
  );

  const { start: startGate, end: endGate } = useMemo(
    () => getVisibleDots(paginationCountGate, activeGate),
    [paginationCountGate, activeGate]
  );

  const { start: startDepartment, end: endDepartment } = useMemo(
    () => getVisibleDots(paginationCountDepartment, activeDepartment),
    [paginationCountDepartment, activeDepartment]
  );

  const { start: startOrg, end: endOrg } = useMemo(
    () => getVisibleDots(paginationCountOrganization, activeOrganization),
    [paginationCountOrganization, activeOrganization]
  );

  const { start: startPurpose, end: endPurpose } = useMemo(
    () => getVisibleDots(paginationCountPurpose, activePurpose),
    [paginationCountPurpose, activePurpose]
  );

  const { start: startMeetingPerson, end: endMeetingPerson } = useMemo(
    () => getVisibleDots(paginationCountMeetingPerson, activeMeetingPerson),
    [paginationCountMeetingPerson, activeMeetingPerson]
  );

  const ProgressDots = ({
    paginationCount,
    start,
    end,
    activeIndex,
    autoplayDelay = 2500,
  }) => {
    // create full indices, then slice
    const indices = useMemo(
      () =>
        Array.from({ length: paginationCount }, (_, i) => i).slice(start, end),
      [paginationCount, start, end]
    );

    return (
      <div className="dotsContainer">
        {indices.map((realIndex) => {
          const isActive = realIndex === activeIndex;
          return (
            <div
              key={realIndex}
              className={`dot ${isActive ? "dot--active" : ""}`}
              style={{ width: isActive ? 28 : 8, height: 8 }} // keep only dynamic width inline
            >
              {isActive && (
                <div
                  className="dot__fill"
                  style={{ animationDuration: `${autoplayDelay}ms` }}
                  aria-hidden
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const ProgressBarRow = ({ name, count, percent, barColor }) => (
    <div className="d-flex justify-content-between rowItem px-2">
      <div className="rowItem__label break-anywhere">{name}</div>

      <div className="d-flex align-items-center">
        <div className="rowItem__bar">
          <div
            className="rowItem__barFill"
            style={{ width: `${percent}%`, backgroundColor: barColor }}
          />
        </div>

        <div className="rowItem__count">{count}</div>
      </div>
    </div>
  );

  const StatisticCard = ({ title, total, items }) => (
    <div className="bg-white p-3 rounded-4">
      <div className="row align-items-end">
        <p style={{ color: "#0D283E", fontSize: "15px", fontWeight: "700" }}>
          {title}
        </p>
        <div className="d-flex flex-column col-2">
          <p
            className="m-0"
            style={{ fontSize: "32px", fontWeight: "600", color: "#172B4D" }}
          >
            {total ?? 0}
          </p>
          <p style={{ color: "#626F86", fontSize: "12px", fontWeight: "400" }}>
            Total entries
          </p>
        </div>
        {items.map((item, index) => (
          <div className="col" key={index}>
            <div
              className="p-3 rounded-4"
              style={{ backgroundColor: "#F6F6F6" }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "13px",
                  fontWeight: "400",
                  color: "#172B4D",
                }}
              >
                {item.label}
              </p>
              <p
                className="m-0"
                style={{
                  color: "#172B4D",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                {item.value ?? 0}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const ProgressBarCard = ({
    icon,
    iconBgColor,
    title,
    data,
    barColor,
    swiperRef,
    activeIndex,
    paginationCount,
    start,
    end,
  }) => (
    <div className="bg-white rounded-4 p-3">
      <div className="row">
        <div className="col-10">
          <div className="d-flex align-items-center gap-3">
            <img
              className="p-2 rounded-circle"
              src={icon}
              alt={title}
              style={{ backgroundColor: iconBgColor }}
            />
            <p className="m-0" style={{ fontSize: "15px", fontWeight: "700" }}>
              {title}
            </p>
          </div>
        </div>

        <div className="col-2 d-flex justify-content-end">
          <ProgressDots
            paginationCount={paginationCount}
            start={start}
            end={end}
            activeIndex={activeIndex}
            autoplayDelay={autoplayDelay}
          />
        </div>

        <Swiper
          onSwiper={(swiper) => {
            if (swiperRef) {
              swiperRef.current = swiper;
            }
          }}
          spaceBetween={12}
          breakpoints={{
            576: { spaceBetween: 16 },
            768: { spaceBetween: 20 },
            1024: { spaceBetween: 28 },
          }}
          loop={paginationCount > 1}
          allowTouchMove={true}
        >
          {/*  {data.map((pageItems, slideIndex) => ( */}
          <SwiperSlide key={activeIndex}>
            <div className="mt-3 d-flex flex-column gap-2">
              {data[activeIndex]?.map((item, i) => (
                <ProgressBarRow
                  key={`item-${i}`}
                  name={item.name}
                  count={item.count}
                  percent={item.percent}
                  barColor={barColor}
                />
              ))}
            </div>
          </SwiperSlide>
          {/* ))} */}
        </Swiper>
      </div>
    </div>
  );

  return (
    <Container
      fluid
      className="main-container"
      style={{
        width: "100vw",
        display: "flex",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      <div style={{ width: "100vw" }}>
        <div>
          <TopBar currentName="dashboard" />
        </div>
        <div
          className="mx-1"
          style={{ width: "100vw", display: "flex", flexDirection: "column" }}
        >
          <div style={{ width: "100vw", padding: "16px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                className="mb-2"
                style={{
                  borderRadius: "100px",
                  padding: "6px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <div
                  onClick={() => {
                    setActiveDashboard("Dashboard");
                    navigate("/dashboard");
                  }}
                  style={{
                    borderRadius: "100px",
                    padding: "8px 20px",
                    gap: "8px",
                    backgroundColor:
                      activeDashboard === "Dashboard" ? "#172B4D" : "#FFFFFF",
                    fontSize: "12px",
                    color:
                      activeDashboard === "Dashboard" ? "#FFFFFF" : "#172B4D",
                    fontWeight: activeDashboard === "Dashboard" ? "600" : "500",
                    cursor: "pointer",
                  }}
                >
                  Dashboard
                </div>
                <div
                  onClick={() => {
                    setActiveDashboard("Visitor Dashboard");
                    navigate("/visitor-dashboard");
                  }}
                  style={{
                    borderRadius: "100px",
                    padding: "8px 20px",
                    gap: "8px",
                    backgroundColor:
                      activeDashboard === "Visitor Dashboard"
                        ? "#172B4D"
                        : "#FFFFFF",
                    fontSize: "13.5px",
                    color:
                      activeDashboard === "Visitor Dashboard"
                        ? "#FFFFFF"
                        : "#172B4D",
                    fontWeight:
                      activeDashboard === "Visitor Dashboard" ? "600" : "500",
                    cursor: "pointer",
                  }}
                >
                  Visitor Dashboard
                </div>
              </div>
              <div className="dashboard">
                <div className="dashboard-head">
                  <div className="dashboard-content">
                    From the date of{" "}
                    <span>
                      {orgCreateDate} to{" "}
                      {new Date().toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-2" style={{ backgroundColor: "#F6F6F6" }}>
              <div>
                {/* <p className="bg-white p-3 ">Visitor dashboard</p> */}
                <div className="row">
                  <div className="col-xl-3">
                    <div className="bg-white p-3 rounded-4 h-100">
                      <div className="row">
                        <div className="col-5 d-flex flex-column gap-1">
                          <p
                            className="m-0"
                            style={{
                              color: "#0D283E",
                              fontSize: "15px",
                              fontWeight: "700",
                            }}
                          >
                            GATE IN
                          </p>
                          <p
                            className="m-0"
                            style={{
                              color: "#0D283E",
                              fontSize: "44px",
                              fontWeight: "700",
                            }}
                          >
                            {liveCount.gate_in ?? 0}
                          </p>
                          <div
                            className="d-flex justify-content-center py-2 rounded-pill align-items-center gap-2"
                            style={{ backgroundColor: "#FFEEEE" }}
                          >
                            <div
                              className="rounded-circle"
                              style={{
                                width: "10px",
                                height: "10px",
                                backgroundColor: "#FF4444",
                              }}
                            ></div>
                            <p
                              className="m-0"
                              style={{ fontSize: "13px", fontWeight: "500" }}
                            >
                              Live count
                            </p>
                          </div>
                        </div>
                        <div className="col-7">
                          <div
                            className="d-flex justify-content-between align-items-center p-3 rounded-3"
                            style={{
                              backgroundColor: "#DAFFED",
                              height: "65px",
                            }}
                          >
                            <p
                              className="m-0"
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "#00B15C",
                              }}
                            >
                              APPROVED
                            </p>
                            <p
                              className="m-0"
                              style={{
                                fontSize: "24px",
                                fontWeight: "600",
                                color: "#0D283E",
                              }}
                            >
                              {liveCount.approved ?? 0}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-between align-items-center p-3 rounded-3 mt-3"
                            style={{
                              backgroundColor: "#FFF2E5",
                              height: "65px",
                            }}
                          >
                            <p
                              className="m-0"
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "#FF7A00",
                              }}
                            >
                              QUEUE
                            </p>
                            <p
                              className="m-0"
                              style={{
                                fontSize: "24px",
                                fontWeight: "600",
                                color: "#0D283E",
                              }}
                            >
                              {liveCount.queue ?? 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-9">
                    <div className="bg-white p-3 rounded-4">
                      <div style={{ borderRadius: 0, position: "relative" }}>
                        {/* Top Header Band */}
                        <div
                          style={{
                            backgroundColor: "#fdeee0",
                            borderRadius: "14px 14px 0 0",
                            padding: "18px 8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 0,
                            gap: 3,
                          }}
                        >
                          <img src={historyClock} alt="clock" />
                          <h1
                            className="m-0"
                            style={{
                              fontSize: "14px",
                              fontWeight: 700,
                              color: "#0D283E",
                            }}
                          >
                            HISTORY
                          </h1>
                        </div>

                        {/* Line below Header */}
                        <div
                          style={{
                            height: 1,
                            backgroundColor: "#cbd5e1",
                            position: "relative",
                          }}
                        >
                          {/* vertical ticks — centered in each column */}
                          {Object.keys(historyCount).map((_, i) => (
                            <div
                              key={i}
                              style={{
                                position: "absolute",
                                left: `calc(${
                                  (i + 0.5) *
                                  (100 / Object.keys(historyCount).length)
                                }%)`,
                                transform: "translateX(-50%)",
                                top: 1,
                                width: 1,
                                height: 26,
                                backgroundColor: "#cbd5e1",
                              }}
                            ></div>
                          ))}
                        </div>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${
                              Object.keys(historyCount).length
                            }, 1fr)`,
                            gap: 0,
                            marginTop: 32,
                          }}
                        >
                          {Object.keys(historyCount).map((key, index) => (
                            <div key={index} className="text-center pt-2 px-2">
                              <div
                                className="fw-bold text-uppercase mb-1"
                                style={{
                                  fontSize: "13px",
                                  color: "#0D283E",
                                  fontWeight: "700",
                                }}
                              >
                                {key.replace(/_/g, " ").toUpperCase()}
                              </div>
                              <div
                                className="fw-bold"
                                style={{
                                  fontSize: "24px",
                                  color: "#0f172a",
                                  fontWeight: "600",
                                }}
                              >
                                {historyCount[key] ?? 0}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-6 mt-3">
                    <StatisticCard
                      title="ENTRY BASED"
                      total={entryCount.total}
                      items={[
                        { label: "QR based", value: entryCount.qr_based },
                        { label: "Manual", value: entryCount.manual },
                      ]}
                    />
                  </div>
                  <div className="col-xl-6 mt-3">
                    <StatisticCard
                      title="REGISTRATION BASED"
                      total={registerCount.total}
                      items={[
                        {
                          label: "Pre registration",
                          value: registerCount.pre_reg,
                        },
                        {
                          label: "Direct Registration",
                          value: registerCount.direct_reg,
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-4 mt-3">
                    <ProgressBarCard
                      icon={locationRed}
                      iconBgColor="#FFEEEE"
                      title="LOCATION BASED"
                      data={chunkArray(locationBased, 5)}
                      barColor="#ef4444"
                      swiperRef={swiperRefLocation}
                      activeIndex={activeLocation}
                      paginationCount={paginationCountLocation}
                      start={startLocation}
                      end={endLocation}
                    />
                  </div>

                  <div className="col-xl-4 mt-3">
                    <ProgressBarCard
                      icon={blueGate}
                      iconBgColor="#EFF0FF"
                      title="GATE BASED"
                      data={chunkArray(gateBased, 5)}
                      barColor="#454CF2"
                      swiperRef={swiperRefGate}
                      activeIndex={activeGate}
                      paginationCount={paginationCountGate}
                      start={startGate}
                      end={endGate}
                    />
                  </div>

                  <div className="col-xl-4 mt-3">
                    <ProgressBarCard
                      icon={greenDepartment}
                      iconBgColor="#DFFFE8"
                      title="DEPARTMENT BASED"
                      data={chunkArray(departmentBased, 5)}
                      barColor="#269144"
                      swiperRef={swiperRefDepartment}
                      activeIndex={activeDepartment}
                      paginationCount={paginationCountDepartment}
                      start={startDepartment}
                      end={endDepartment}
                    />
                  </div>

                  <div className="col-xl-4 mt-3">
                    <ProgressBarCard
                      icon={blueOrg}
                      iconBgColor="#EDE5FF"
                      title="ORGANIZATION BASED"
                      data={chunkArray(orgBased, 5)}
                      barColor="#512DA8"
                      swiperRef={swiperRefOrganization}
                      activeIndex={activeOrganization}
                      paginationCount={paginationCountOrganization}
                      start={startOrg}
                      end={endOrg}
                    />
                  </div>

                  <div className="col-xl-4 mt-3">
                    <ProgressBarCard
                      icon={greyPurpose}
                      iconBgColor="#EFEFEF"
                      title="PURPOSE BASED"
                      data={chunkArray(purposeBased, 5)}
                      barColor="#66737E"
                      swiperRef={swiperRefPurpose}
                      activeIndex={activePurpose}
                      paginationCount={paginationCountPurpose}
                      start={startPurpose}
                      end={endPurpose}
                    />
                  </div>

                  <div className="col-xl-4 mt-3">
                    <ProgressBarCard
                      icon={meetingPerson}
                      iconBgColor="#FFF3E2"
                      title="MEETING PERSON BASED"
                      data={chunkArray(meetingPersonBased, 5)}
                      barColor="#C57709"
                      swiperRef={swiperRefMeetingPerson}
                      activeIndex={activeMeetingPerson}
                      paginationCount={paginationCountMeetingPerson}
                      start={startMeetingPerson}
                      end={endMeetingPerson}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default VisitorDashboard;
